import { FC } from 'react';

import { Icon } from '@pp/core/src/components/icons/icon';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import styles from './PreviousRound.module.css';

interface PreviousRoundProps {
  show: boolean;
  setShow: (value: boolean) => void;
  showStaticData: { static: boolean; previous: boolean };
}

export const PreviousRound: FC<PreviousRoundProps> = ({ show, setShow, showStaticData }) => {
  const audioTrigger = useAudioTrigger();
  const _show = showStaticData.previous ? false : show;
  // const _show = show;

  const mods = useModifiers(styles, 'previousRound', {
    close: !_show,
    static: showStaticData.static,
  });

  const handlePreviousClick = ():void => {
    setShow(!_show);
    audioTrigger.play({ name: 'menuClick' });
  };

  return (
    <div onClick={handlePreviousClick} className={`${styles.previousRound} ${mods}`}>
      <div className={styles.previousRound_title}>
        {showStaticData.static ? 'Previous Round' : <L10nText tk="PREVIOUS_ROUND" />}
      </div>
      <button className={styles.previousRound_button}>
        <Icon icon={_show ? Icons.History : Icons.Close} color={'white'}></Icon>
      </button>
    </div>
  );
};
